import { useQuery } from "@tanstack/react-query";
import { useWorkScope } from "../components/WorkScopeProvider";
import {
  fetchManualProcedure,
  fetchProcedureCategories,
  type ProcedureCategoryOption,
} from "./procedureAuthoringApi";

export function useProcedureAuthoringQuery(procedureId?: string) {
  const { selectedCustomer, selectedFacility } = useWorkScope();

  return useQuery({
    queryKey: [
      "procedure-authoring",
      selectedCustomer?.id,
      selectedFacility?.id,
      procedureId,
    ],
    enabled: Boolean(selectedCustomer && selectedFacility && procedureId),
    queryFn: async () => {
      if (!selectedCustomer || !selectedFacility || !procedureId) {
        throw new Error(
          "A customer, facility, and procedure must be selected.",
        );
      }
      return fetchManualProcedure(
        selectedCustomer.id,
        selectedFacility.id,
        procedureId,
      );
    },
    meta: { errorMessage: "Unable to load this Procedure." },
  });
}

export function useProcedureCategoriesQuery() {
  const { selectedCustomer, selectedFacility } = useWorkScope();

  return useQuery<ProcedureCategoryOption[]>({
    queryKey: [
      "procedure-authoring-categories",
      selectedCustomer?.id,
      selectedFacility?.id,
    ],
    enabled: Boolean(selectedCustomer && selectedFacility),
    queryFn: async () => {
      if (!selectedCustomer || !selectedFacility) {
        throw new Error("A customer and facility must be selected.");
      }
      return fetchProcedureCategories(selectedCustomer.id, selectedFacility.id);
    },
    meta: { errorMessage: "Unable to load procedure categories." },
  });
}
